/**
 * Created by zhangrp on 2018/4/3.
 */

import {Utils} from '../../app.base';
import {MsgBox, Vue} from '../../app.vues';
import shopDevcApi from '../../api/shopDevc';

import SwbDefServicerForSelect from '../servicer/DefServicerForSelect';
import SwbShopDeviceSvcNoForSelectCurrContract from './ShopDeviceSvcNoForSelectCurrContract';
import ShopDeviceFormatExpl from './ShopDeviceFormatExpl';
import SwbEvalWeight from './EvalWeight';
import SwbShopDeviceSvcSubNoListForSelect from './ShopDeviceSvcSubNoListForSelect';
import SwbRetailerOrgTree from './RetailerOrgTree';
import SwbShopDeviceTransVoucherAudit from '../transVoucher/ShopDeviceTransVoucherAudit';

import SwbShopDeviceTransVoucherConfirm from '../transVoucher/ShopDeviceTransVoucherConfirm';
import SwbAssetStockCheckContrast from './AssetStockCheckContrast';
import SwbStuffStockCheckContrast from './StuffStockCheckContrast';
import SwbShopDeviceSuitListForSelect from './ShopDeviceSuitListForSelect';
import SwbShopDeviceMaintProofRelList from './ShopDeviceMaintProofRelList';
import SwbShopDeviceBatchStockListLowCostForSelect from './ShopDeviceBatchStockListLowCostForSelect'
import SwbShopDeviceAppReturnVoucherAudit from './ShopDeviceAppReturnVoucherAudit';
import SwbDevcInfoFormList from './DevcInfoFormList';
import SwbDevcInfoFormTplListForSelect from './DevcInfoFormTplListForSelect';
import SwbShopDeviceStockFileList from './ShopDeviceStockFileList';
import SwbShopDeviceStockCheckVoucherPdf from './ShopDeviceStockCheckVoucherPdf'
import SwbShopStuffStockCheckVoucherPdf from './ShopStuffStockCheckVoucherPdf'
import SwbShopDeviceStockCheckVoucherFinishedPdf from './ShopDeviceStockCheckVoucherFinishedPdf'
import SwbLowCostImpCheck from '../shopStuff/LowCostImpCheck';
import SwbShopDeviceGrabIssueDetail from './ShopDeviceGrabIssueDetail';
import SwbAssetFiscalInImpCheck from './AssetFiscalInImpCheck';
import SwbAssetOuterUnsettledImpCheck from './AssetOuterUnsettledImpCheck';
/**
 *
 * @param queryFilter
 * @param callbackFunc
 */

Vue.regist(SwbDefServicerForSelect);
Vue.regist(SwbShopDeviceSvcNoForSelectCurrContract);
Vue.regist(ShopDeviceFormatExpl);
Vue.regist(SwbEvalWeight);
Vue.regist(SwbShopDeviceSvcSubNoListForSelect);
Vue.regist(SwbRetailerOrgTree);
Vue.regist(SwbShopDeviceTransVoucherAudit);
Vue.regist(SwbShopDeviceTransVoucherConfirm);
Vue.regist(SwbAssetStockCheckContrast);
Vue.regist(SwbStuffStockCheckContrast);
Vue.regist(SwbShopDeviceSuitListForSelect);
Vue.regist(SwbShopDeviceMaintProofRelList);
Vue.regist(SwbShopDeviceAppReturnVoucherAudit);
Vue.regist(SwbDevcInfoFormList);
Vue.regist(SwbDevcInfoFormTplListForSelect);
Vue.regist(SwbShopDeviceStockFileList);
Vue.regist(SwbShopDeviceStockCheckVoucherPdf);
Vue.regist(SwbShopStuffStockCheckVoucherPdf);
Vue.regist(SwbShopDeviceStockCheckVoucherFinishedPdf);
Vue.regist(SwbShopDeviceBatchStockListLowCostForSelect);
Vue.regist(SwbLowCostImpCheck);
Vue.regist(SwbShopDeviceGrabIssueDetail);
Vue.regist(SwbAssetFiscalInImpCheck);
Vue.regist(SwbAssetOuterUnsettledImpCheck);

//门店设备-选择合同中的默认服务商
export function openDefServicerSelectDlgContract(self, data, callback) {
    let theDlg = Vue.$showDialog({
        title: '选择默认服务商',
        height: '80%',
        showCloseBtn: true,
        template: '<div>' +
        '<swb-def-servicer-for-select :multiSelect="false" :initCheckedItem="initCheckedItem" ref="swb_def_servicer_for_select"></swb-def-servicer-for-select>' +
        '</div>',
        data: {
            initCheckedItem: data
        },
        okClicked: function () {
            let result = this.$refs.swb_def_servicer_for_select.getDlgResult() || {};
            if (result.type == "info") {
                //
                callback(result.data);
                return true;
            } else {
                self.$message.warning(result.message);
            }
            return false;
        },
        methods: {}
    });
}

//门店设备-选择商户关系中的默认服务商
export function openDefServicerSelectDlg(self, id, data, callback) {
    let theDlg = Vue.$showDialog({
        title: '选择默认服务商',
        height: '80%',
        showCloseBtn: true,
        template: '<div>' +
        '<swb-merchant-biz-rel-select :propMerchantType="propMerchantType"  ref="swb_merchant_biz_rel_select"></swb-merchant-biz-rel-select>' +
        '</div>',
        data: {
            propMerchantType: getEnumInfoWith("merchantType", 'name', 'Servicer').value
        },
        okClicked: function () {
            let result = this.$refs.swb_merchant_biz_rel_select.getDlgResult() || {};
            if (result.type == "info") {
                //保存默认服务商
                let postData = {
                    id: id,
                    defServicerId: result.data.peerMerchantId,
                    defServicerName: result.data.peerMerchantName
                };
                shopDevcApi.updateDefServicer(postData, function (result) {
                    if (result.type == "info") {
                        self.$message.success(result.message);
                        self.getShopDeviceList();
                        theDlg.close();
                    }
                });
            } else {
                self.$message.warning(result.message);
            }
            return false;
        },
        methods: {}
    });
}
//门店设备服务号-选择合同
export function openCurrContractSelectDlg(self, parameters, callback) {
    let theDlg = Vue.$showDialog({
        title: '选择合同',
        height: '80%',
        width: '80%',
        showCloseBtn: true,
        template: '<div>' +
        '<swb-contract-list-select :no="no" ref="swb_contract_list_select"></swb-contract-list-select>' +
        '</div>',
        data: {
            no: parameters.currContractNo
        },
        okClicked: function () {
            let result = this.$refs.swb_contract_list_select.getDlgResult() || {};
            if (result.type == "info") {
                let postData = {
                    id: parameters.id,
                    currContractNo: result.data.currContractNo
                };
                shopDevcApi.updateShopDeviceSvcNoByCurrContract(postData, function (result) {
                    if (result.type == "info") {
                        self.$message.success(result.message);
                        self.getShopDeviceSvcSubNoByComId();
                        theDlg.close();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            } else {
                self.$message.warning(result.message);
            }
            return false;
        },
        methods: {}
    });
}

//机构设备导入详细列表
export function openShopDeviceImpItemListDlg(params, callback) {
    let recId = params['recId'] || null;
    let deviceFlag = params["deviceFlag"];
    let theDlg = Vue.$showDialog({
        title: Utils.isTrue(deviceFlag) ? "机构设备导入详细列表" : "机构资产导入详细列表",
        width: "90%",
        height: -100,
        okVisible: false,
        showCloseBtn: true,
        cancelText: '关闭',
        template: '<swb-shop-device-imp-item-list :recId="recId" :deviceFlag="deviceFlag"  ref="swb_shop_device_imp_item_list"></swb-shop-device-imp-item-list>',
        data: {
            recId: recId,
            deviceFlag: Utils.isTrue(deviceFlag)
        },
        methods: {
            theDlgClose: function () {
                theDlg.close();
            }
        }
    });
};

//机构设备导入格式说明
export function ShopDeviceFormatExplDlg(assetType, normalFlag) {
    Vue.$showDialog({
        title: "导入文件格式说明",
        width: "90%",
        height: "90%",
        okVisible: false,
        showCloseBtn: true,
        cancelText: '关闭',
        template: '<swb-shop-device-format-expl :assetType="assetType"></swb-shop-device-format-expl>',
        data: {
            assetType: assetType
        },
    });
};

export function openRetailComTreeSelectDlg(dlgConfig = {}, callback) {
    if (Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if (typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let title = dlgConfig['title'] || "买家公司--选择";
    let enableSearch = dlgConfig['enableSearch'] || null; // 是否可以搜索
    let isRadio = dlgConfig['isRadio'] || false; // 是否可以单选
    let isShowIcon = dlgConfig['isShowIcon'] || false; // 是否可以伸缩
    let accordion = dlgConfig['accordion'] || false; // 是否手风琴模式
    let merchantId = dlgConfig['merchantId'] || null; // 零售商商户id
    let bizUnitId = dlgConfig['bizUnitId'] || null; // 零售商商户id
    let deaprtFlag = dlgConfig['deaprtFlag'] || false; // 业务部门可选
    let bizDepart = dlgConfig['bizDepart'] || false; // 业务部门可选
    let isCom = dlgConfig['isCom'] || false; // 业务部门可选
    let showMerchtSelect = dlgConfig['showMerchtSelect'] || false; // 展示分管商户下拉选
    if (bizDepart == false) {
        bizDepart = deaprtFlag;
    }
    let optionalState = dlgConfig['optionalState'] || [1, 3];
    let defalultState = dlgConfig['defalultState'] || [1, 3];
    //
    Vue.$showDialog({
        title: title,
        width: 800,
        height: 600,
        showCloseBtn: true,
        //okVisible: true,
        // cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-retail-org-tree :optionalState="optionalState" :defalultState="defalultState" :isCom="isCom" :enableSearch="enableSearch" :isRadio="isRadio" :isShowIcon="isShowIcon" :accordion="accordion" :merchantId="merchantId" :bizUnitId="bizUnitId" :bizDepart="bizDepart" :showMerchtSelect="showMerchtSelect" ref="swb_retail_org_tree"></swb-retail-org-tree>' +
        '</div>',
        data: {
            enableSearch: enableSearch,
            isRadio: isRadio,
            isShowIcon: isShowIcon,
            accordion: accordion,
            merchantId: merchantId,
            bizUnitId: bizUnitId,
            bizDepart: bizDepart,
            isCom: isCom,
            showMerchtSelect: showMerchtSelect,
            optionalState: optionalState,
            defalultState: defalultState
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_retail_org_tree.getDlgResult() || {};
            if (result.type == "info") {
                let retailerCom = result.data;
                //
                let callbockResult = callback(retailerCom);
                if(typeof callbockResult != 'undefined' && callbockResult != null) {
                    return callbockResult;
                }
            } else {
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

// 调拨单审核页面
export function openShopDeviceTransVoucherAuditDlg(crossComFlag, lowCostFlag, callback, id) {
    let title = Utils.isTrue(lowCostFlag) ? '耗材调拨单 - 审核' : '资产调拨单 - 审核';
    Vue.$showDialog({
        title: title,
        width: 500,
        height: 400,
        showCloseBtn: true,
        template: '<div>' +
        '<swb-shop-device-trans-voucher-audit :crossComFlag="crossComFlag" :id="id" ref="swb_shop_device_trans_voucher_audit"></swb-shop-device-trans-voucher-audit>' +
        '</div>',
        data: {
            lowCostFlag: lowCostFlag,
            crossComFlag: crossComFlag,
            id: id,
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_shop_device_trans_voucher_audit.getDlgResult() || {};
            if (result.type === 'info') {
                let transVoucher = result.data;
                callback(transVoucher);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

// 设备调拨单确认
export function openShopDeviceTransVoucherConfirmDlg(id, dstComId, dstComName, crossFlag, crossComFlag, dstWarehouseId, warehouseId, lowCostFlag, callback) {
    let title = Utils.isTrue(lowCostFlag) ? '耗材调拨单 - 确认' : '资产调拨单 - 确认';
    Vue.$showDialog({
        title: title,
        width: -200,
        height: -200,
        showCloseBtn: true,
        template: '<div>' +
        '<swb-shop-device-trans-voucher-confirm :id="id" :lowCostFlag="lowCostFlag" :dstComId="dstComId" :dstComName="dstComName" :crossFlag="crossFlag" :crossComFlag="crossComFlag" :dstWarehouseId="dstWarehouseId" :srcWarehouseId:="srcWarehouseId" ref="swb_shop_device_trans_voucher_confirm"></swb-shop-device-trans-voucher-confirm>' +
        '</div>',
        data: {
            dstComId: dstComId,
            dstComName: dstComName,
            srcWarehouseId: warehouseId,
            crossFlag: crossFlag,
            crossComFlag: crossComFlag,
            dstWarehouseId: dstWarehouseId,
            lowCostFlag: lowCostFlag,
            id: id,
        },
        methods: {}
        ,
        okClicked: function () {
            let result = this.$refs.swb_shop_device_trans_voucher_confirm.getDlgResult() || {};
            if (result.type === 'info') {
                let confirmInfo = result.data;
                callback(confirmInfo);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
        ,
        lifecycle: {
            created: function () {
            }
        }
    });
}

// 领用归还单审核页面
export function openShopDeviceAppReturnVoucherAuditDlg(title, prams, callback) {
    Vue.$showDialog({
        title: title + "单 - 审核",
        width: 500,
        height: 400,
        showCloseBtn: true,
        template: '<div>' +
        '<swb-app-return-voucher-audit :assetType="assetType" ref="swb_app_return_voucher_audit"></swb-app-return-voucher-audit>' +
        '</div>',
        data: {
            assetType: prams.assetType
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_app_return_voucher_audit.getDlgResult() || {};
            if (result.type === 'info') {
                let resultDate = result.data;
                callback(resultDate);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

// 资产盘点单对比
export function openAsserStockCheckContrastDlg(voucherIds) {
    if (Utils.isNoB(voucherIds)) {
        MsgBox.warning("参数错误!");
        return;
    }
    if (voucherIds.length < 2) {
        MsgBox.warning("最少对比两个");
        return;
    }
    Vue.$showDialog({
        title: "资产盘点单对比",
        width: '90%',
        height: '90%',
        okVisible: false,
        cancelText: "关闭",
        template: '<div>' +
        '<swb-asset-stock-check-contrast :voucherIds="voucherIds" ref="swb_asset_stock_check_contrast"></swb-asset-stock-check-contrast>' +
        '</div>',
        data: {
            voucherIds: voucherIds
        }
    });
}

// 耗材盘点单对比
export function openStuffStockCheckContrastDlg(voucherIds) {
    if (Utils.isNoB(voucherIds)) {
        MsgBox.warning("参数错误!");
        return;
    }
    if (voucherIds.length < 2) {
        MsgBox.warning("最少对比两个");
        return;
    }
    Vue.$showDialog({
        title: "耗材盘点单对比",
        width: '90%',
        height: '90%',
        okVisible: false,
        cancelText: "关闭",
        template: '<div>' +
        '<swb-stuff-stock-check-contrast :voucherIds="voucherIds" ref="swb_asset_stock_check_contrast"></swb-stuff-stock-check-contrast>' +
        '</div>',
        data: {
            voucherIds: voucherIds
        }
    });
}

/**
 * params: {
 *      根据分类分组过滤主资产信息
 *      devceGroupId: 专业分类分组id
 *      servicerId: 服务商id
 * }
 *
 * @param params
 * @param callback
 * @param selectTmpNos
 */
export function openShopDeviceSuitSelectDlg(params, callback, selectTmpNos) {
    //
    let theDlg = Vue.$showDialog({
        title: "资产套装选择",
        width: 1200,
        height: 800,
        template: '<swb-shop-device-suit-list-for-select :filter="filter" :selectTmpNos="selectTmpNos" ref="swb_shop_device_suit_list_for_select"></swb-shop-device-suit-list-for-select>',
        data: {
            filter: params,
            selectTmpNos: selectTmpNos
        },
        methods: {},
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_shop_device_suit_list_for_select.getDlgResult() || {};
            if (result.type == 'info') {
                let suitList = result.data;
                callback(suitList);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

// //设备关联凭单列表
export function openShopDeviceMintProofRelListDlg(deviceXId) {
    Vue.$showDialog({
        title: "凭单管理",
        width: 800,
        height: 700,
        okVisible: false,
        showCloseBtn: true,
        cancelText: '关闭',
        template: '<div>' +
        '<swb-devc-maint-proof-rel-list :devcSubNoId="deviceXId" ref="swb_devc_maint_proof_rel_list"></swb-devc-maint-proof-rel-list>' +
        '</div>',
        data: {
            deviceXId: deviceXId
        }
    });
}

// singFilter 单品需要查询信息{ voucherType：null, inspectFlowFlag:检验流程信息id或-1}
// singlecheck 单品判断信息 {isShowSelection：true， showTransLocked：false， disabledVoucher：false，specialFlag, setupFlag:是否需要安装, setupDone: 是否已安装, patrolFlag:是否需巡查, maintFlag: 是否需保养, inspectFlag: 是否需检验}
// selectIds 单品选择过得数据
// batchFilter 批次需要查询信息{lowCostFlag 是否有耗材， vendorType:单据类型,inspectFlowFlag:检验流程信息id或-1，inspectFlag: 是否需检验}
// batchCheck 批量判断信息{showBatch 是否显示耗材}
// checkedBatchIds 批次选择过的数据
// selectSingle:false 只选择单品
// selectBatch:false 只选择批量
// selectAll:true 选择单品或批量
export function showAssetSelectDlg(dlgConfig, callback, selfClose) {
    let title = dlgConfig["title"] || "选择资产";
    let singleFilter = dlgConfig["singleFilter"];
    let selectSingleIds = dlgConfig["selectSingleIds"] || [];
    let singlecheck = dlgConfig["singlecheck"];
    let batchFilter = dlgConfig["batchFilter"];
    let selectBatchIds = dlgConfig["selectBatchIds"] || [];
    let batchCheck = dlgConfig["batchCheck"];
    let selectSingle = dlgConfig["selectSingle"] == null ? false : dlgConfig["selectSingle"];
    let selectBatch = dlgConfig["selectBatch"] == null ? false : dlgConfig["selectBatch"];
    let selectAll = dlgConfig["selectAll"] == null ? false : dlgConfig["selectAll"];
    let showOrgTree = dlgConfig["showOrgTree"] == null ? false : dlgConfig["showOrgTree"];
    let showMgmt = dlgConfig["showMgmt"] == null ? false : dlgConfig["showMgmt"];
    let bizDepart = dlgConfig["bizDepart"] == null ? false : dlgConfig["bizDepart"];
    let adjustFlag = dlgConfig["adjustFlag"] == null ? false : dlgConfig["adjustFlag"]; // 为了调整隐藏不入账、已入账、已出账的搜索
    let showIncludeSubComs = dlgConfig["showIncludeSubComs"] == null ? true : dlgConfig["showIncludeSubComs"]; // 显示组织机构及以下选项，默认显示
    let sellerId = dlgConfig["sellerId"] || null;//延保需要
    let bizType = dlgConfig["bizType"];
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1200,
        height: 900,
        cancelVisible: true,
        okVisible: true,
        template: '<device-for-select-list :bizType="bizType" :adjustFlag="adjustFlag" :showOrgTree="showOrgTree" :showMgmt="showMgmt" :showIncludeSubComs="showIncludeSubComs" :bizDepart="bizDepart" :singleFilter="singleFilter" :selectSingleIds="selectSingleIds" :singlecheck="singlecheck" :batchFilter="batchFilter" :selectBatchIds="selectBatchIds" :batchCheck="batchCheck" :selectSingle="selectSingle" :selectBatch="selectBatch" :selectAll="selectAll" :sellerId="sellerId" ref="device_select_list"></device-for-select-list>',
        data: {
            singleFilter: singleFilter,
            selectSingleIds: selectSingleIds,
            batchFilter: batchFilter,
            selectBatchIds: selectBatchIds,
            selectSingle: selectSingle,
            selectBatch: selectBatch,
            selectAll: selectAll,
            batchCheck: batchCheck,
            singlecheck: singlecheck,
            showOrgTree: showOrgTree,
            showMgmt: showMgmt,
            showIncludeSubComs: showIncludeSubComs,
            bizDepart: bizDepart,
            adjustFlag: adjustFlag,
            sellerId: sellerId,
            bizType: bizType
        },
        okClicked: function () {
            let self = this;
            let theLoad = MsgBox.loading();
            setTimeout(function () {
                let result = self.$refs.device_select_list.getDlgResult() || {};
                if (result.type === 'info') {
                    if (Utils.isNoB(selfClose) || !selfClose) {
                        callback(result.data, theLoad);
                        theDlg.close();
                    } else {
                        callback(result.data, theLoad, theDlg);
                    }
                } else {
                    MsgBox.warning(result.message);
                }
                theLoad.hide();
            }, 0);
            return false;
        }
    });
}
export function showLowCostSelectDlg(dlgConfig, callback, selfClose) {
    let title = dlgConfig["title"] || "选择耗材";
    let selectIds = dlgConfig["selectIds"] || [];
    let selectioned = dlgConfig["selectioned"] || false;
    let filter = dlgConfig["filter"] || {};
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1200,
        height: 900,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-shop-device-batch-stock-lowcost-list-select :selectIds="selectIds" :selectioned="selectioned" :filter="filter"  ref="swb_shop_device_batch_stock_lowcost_list_select"></swb-shop-device-batch-stock-lowcost-list-select>',
        data: {
            selectIds: selectIds,
            selectioned: selectioned,
            filter: filter
        },
        okClicked: function () {
            let self = this;
            let theLoad = MsgBox.loading();
            setTimeout(function () {
                let result = self.$refs.swb_shop_device_batch_stock_lowcost_list_select.getDlgResult() || {};
                if (result.type === 'info') {
                    if (Utils.isNoB(selfClose) || !selfClose) {
                        callback(result.data, theLoad);
                        theDlg.close();
                    } else {
                        callback(result.data, theLoad, theDlg);
                    }
                } else {
                    MsgBox.warning(result.message);
                }
                theLoad.hide();
            }, 0);
            return false;
        }
    });
}

//设备信息单列表弹框
export function openDevcInfoFormListDlg(devcId, devcNo) {
    Vue.$showDialog({
        title: "设备信息单列表",
        width: 1200,
        height: '100%',
        okVisible: false,
        showCloseBtn: false,
        template: '<div>' +
        '<swb-devc-info-form-list :devcId="devcId" :devcNo="devcNo"></swb-devc-info-form-list>' +
        '</div>',
        data: {
            devcId: devcId,
            devcNo: devcNo
        }
    });
}
//
import SwbRetailerComListForSelect from '../retailer/RetailerComListForSelect';
Vue.regist(SwbRetailerComListForSelect);
//
export function openRetailerComListForSelectDlg(queryFilter, callbackFunc) {
    let confKey = queryFilter['confKey'] || null;
    let checkedComList = queryFilter['checkedComList'] || [];
    let disabledIds = queryFilter['disabledIds'] || [];
    let bizAreaIds = queryFilter['bizAreaIds'] || [];
    let bizFormIds = queryFilter['bizFormIds'] || [];
    let ids = queryFilter['ids'] || [];
    let realComId = queryFilter['realComId'] || null;
    let signGroupId = queryFilter['signGroupId'] || null;
    let orgType = queryFilter['orgType'] || null;
    let bizUnitType = queryFilter['bizUnitType'] || null;
    let comLevel = queryFilter['comLevel'] || null;
    let comId = queryFilter['comId'] || null;
    let shopFlag = queryFilter['shopFlag'];
    let bizUnitShopFlag = queryFilter['bizUnitShopFlag'];
    let bizUnitLevels = queryFilter['bizUnitLevels'] || [];
    let states = queryFilter['states'] || [1, 3];
    let bizUnitId = queryFilter['bizUnitId'] || null;
    let isCom = Utils.isTrue(queryFilter['isCom']);
    let checkBox = queryFilter['checkBox'];
    let filterMerchantId = queryFilter['filterMerchantId'] == null ? true : Utils.isTrue(queryFilter['filterMerchantId']); // 根据merchantId过滤，后台默认是根据merchantId过滤的
    let merchantId = queryFilter['merchantId'] || null;
    if (Utils.isNoB(checkBox)) {
        checkBox = true;
    }
    //
    let theDlg = Vue.$showDialog({
        title: "零售商机构 - 选择",
        width: -400,
        height: 750,
        showCloseBtn: true,
        template: '<swb-retailer-com-list-for-select :confKey="confKey" :filter="filter" :isCom="isCom" :states="states" :checkBox="checkBox" :checkedComList="checkedComList" :disabledIds="disabledIds" ref="swb_retailer_com_list_for_select"></swb-retailer-com-list-for-select>',
        data: {
            filter: {
                merchantId: merchantId,
                bizAreaIds: bizAreaIds,
                bizFormIds: bizFormIds,
                comId: comId,
                comLevel: comLevel,
                ids: ids,
                orgType: orgType,
                bizUnitType: bizUnitType,
                realComId: realComId,
                signGroupId: signGroupId,
                shopFlag: shopFlag,
                bizUnitLevels: bizUnitLevels,
                bizUnitShopFlag: bizUnitShopFlag,
                bizUnitId: bizUnitId,
                filterMerchantId: filterMerchantId
            },
            checkedComList: checkedComList,
            disabledIds: disabledIds,
            isCom: isCom,
            checkBox: checkBox,
            confKey: confKey,
            states: states
        },
        okClicked: function () {
            let selfDlg = this;
            let result = null;
            if(Utils.isNoB(confKey)){
                result = selfDlg.$refs.swb_retailer_com_list_for_select.getDlgResult() || {};
            } else {
                result = selfDlg.$refs.swb_retailer_com_list_for_select.getDlgResultForKey() || {};
            }
            if (result.type === 'info') {
                let retailerComList = result.data;
                callbackFunc(retailerComList, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

//设备信息单模版选择弹框
export function openDevcInfoFormTplSelectDlg(selectId = null, callbackFunc) {
    Vue.$showDialog({
        title: "设备信息单模版",
        width: 1200,
        height: 800,
        okVisible: true,
        showCloseBtn: false,
        template: '<div>' +
        '<swb-devc-info-form-tpl-list-select :selectId="selectId" ref="swb_devc_info_form_tpl_list_select"></swb-devc-info-form-tpl-list-select>' +
        '</div>',
        data: {
            selectId: selectId
        },
        okClicked: function () {
            let result = this.$refs.swb_devc_info_form_tpl_list_select.getDlgResult() || {};
            if (result.type == 'info') {
                callbackFunc(result.data);
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
    });
}

export function openStockFileDlg(id, usage, callback) {
    //
    let self = this;
    let theDlg = Vue.$showDialog({
        title: '审批结果',
        width: 1100,
        height: 750,
        template: '<div class = "">' +
        '<swb-shop-device-stock-file-edit :id="id" :usage="usage" ref="swb_shop_device_stock_file_edit"></swb-shop-device-stock-file-edit>' +
        '</div>',
        data: {
            id: id,
            usage: usage,
        },
        okClicked: function () {
            let resultData = this.$refs.swb_shop_device_stock_file_edit.getDlgResult() || {};
            if (resultData.type === 'info') {
                callback(resultData.data)
            } else {
                MsgBox.warning(resultData.message);
                return false;
            }
        }
    });
}

export function openCheckVouhcerPdfDlg(voucherId) {
    //
    Vue.$showDialog({
        title: "业务单据 - 查看",
        width: 1200,
        height: 800,
        okVisible: false,
        showCloseBtn: true,
        okClicked: false,
        cancelText: '关闭',
        template: '<div>' +
        '<swb-shop-device-stcok-check-voucher-pdf :voucherId="id"></swb-shop-device-stcok-check-voucher-pdf>' +
        '</div>',
        data: {
            id: voucherId
        }
    });
}
export function openStuffCheckVouhcerPdfDlg(voucherId) {
    //
    Vue.$showDialog({
        title: "业务单据 - 查看",
        width: 1200,
        height: 800,
        okVisible: false,
        showCloseBtn: true,
        okClicked: false,
        cancelText: '关闭',
        template: '<div>' +
        '<swb-shop-stuff-stcok-check-voucher-pdf :voucherId="id"></swb-shop-stuff-stcok-check-voucher-pdf>' +
        '</div>',
        data: {
            id: voucherId
        }
    });
}
export function openCheckVouhcerFinishedPdfDlg(voucherId, assetType) {
    //
    Vue.$showDialog({
        title: "业务单据 - 查看",
        width: 1200,
        height: 800,
        okVisible: false,
        showCloseBtn: true,
        okClicked: false,
        cancelText: '关闭',
        template: '<div>' +
        '<swb-shop-device-stcok-check-voucher-finished-pdf :voucherId="id" :assetType="assetType"></swb-shop-device-stcok-check-voucher-finished-pdf>' +
        '</div>',
        data: {
            id: voucherId,
            assetType: assetType
        }
    });
}

//
import SwbSetTemperInfo from './SetTemperInfo';
Vue.regist(SwbSetTemperInfo);
export function showSetTemperInfoDlg(dlgConfig, callback) {
    let title = dlgConfig["title"] || "资产温控 - 设置";
    let theDlg = Vue.$showDialog({
        title: title,
        width: 680,
        height: 360,
        template: '<swb-set-temper-info ref="swb_set_temper_info"></swb-set-temper-info>',
        data: {},
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_set_temper_info.getDlgResult() || {};
            if (result.type === 'info') {
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

// 设备巡检时段设置
import SwbDevicePatrolPeriodSave from './DevicePatrolPeriodSave';
Vue.regist(SwbDevicePatrolPeriodSave);
export function showDevicePatrolPeriodSaveDlg(dlgConfig, callback) {
    let id = dlgConfig["id"] || null;
    let defComId = dlgConfig["defComId"] || null;
    let title = id == null ? '巡查时段设置 - 新增' : '巡查时段设置 - 修改';
    let theDlg = Vue.$showDialog({
        title: title,
        width: 800,
        height: 500,
        template: '<swb-device-patrol-period-save :id="id" :defComId="defComId" ref="swb_device_patrol_period_save"></swb-device-patrol-period-save>',
        data: {
            id: id,
            defComId: defComId
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_device_patrol_period_save.getDlgResult() || {};
            if (result.type === 'info') {
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

import SwbRetailerListForSelect from './RetailerListForSelect';
Vue.regist(SwbRetailerListForSelect);

export function openRetailerListForSelectDlg(dlgConfig = {}, callback) {
    let isMultiple = dlgConfig['isMultiple'];
    let selectCheckComInfo = dlgConfig['selectCheckComInfo'] || null;
    //
    let theDlg = Vue.$showDialog({
        title: '零售商 - 选择',
        width: 900,
        height: 850,
        showCloseBtn: true,
        template: '<swb-retailer-list-for-select :isMultiple="isMultiple" :selectCheckComInfo="selectCheckComInfo" ref="swb_retailer_list_for_select" ></swb-retailer-list-for-select>',
        data: {
            isMultiple: isMultiple,
            selectCheckComInfo: selectCheckComInfo,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_retailer_list_for_select.getDlgResult() || {};
            if (result.type == "info") {
                let retailer = result.data;
                //
                callback(retailer, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}
import SwbShopDeviceStockHandleItemAuditStateList from './ShopDeviceStockHandleItemAuditStateList';
Vue.regist(SwbShopDeviceStockHandleItemAuditStateList);
export function openHandleItemAuditDlg(dlgConfig = {}, callback) {
    let auditFlag = dlgConfig['auditFlag'] ? dlgConfig['auditFlag'] : false;
    let applyFlag = dlgConfig['applyFlag'] ? dlgConfig['applyFlag'] : false;
    let voucherId = dlgConfig['voucherId'] || null;
    let okClicked = true;
    let cancelText = '取消';
    if (Utils.isTrue(auditFlag) || (!Utils.isTrue(auditFlag) && !Utils.isTrue(applyFlag))) {
        okClicked = false;
        cancelText = '关闭';
    }
    let title = "处理明细 - 详情";
    if (Utils.isTrue(auditFlag)) {
        title = "处理明细 - 审核";
    } else if (Utils.isTrue(applyFlag)) {
        title = "处理明细 - 申请";
    }
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: -200,
        height: 850,
        showCloseBtn: true,
        okVisible: okClicked,
        cancelText: cancelText,
        template: '<swb-shop-device-stock-handle-item-audit-list :voucherId="voucherId" :applyFlag="applyFlag" :auditFlag="auditFlag" ref="swb_shop_device_stock_handle_item_audit_list" ></swb-shop-device-stock-handle-item-audit-list>',
        data: {
            voucherId: voucherId,
            applyFlag: applyFlag,
            auditFlag: auditFlag,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_shop_device_stock_handle_item_audit_list.getDlgResult() || {};
            if (result.type == "info") {
                let resultData = result.data;
                //
                callback(resultData, theDlg, true);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        cancelClicked: function () {
            callback(null, theDlg, false);
        }
    });
}

import SwbRetailerComRoleSelect from './RetailerComRoleSelect'
Vue.regist(SwbRetailerComRoleSelect);
//门店设备服务号-选择合同
export function openRetailerComRoleSelectDlg(callback) {
    let theDlg = Vue.$showDialog({
        title: '选择岗位',
        height: '80%',
        width: '60%',
        showCloseBtn: true,
        template: '<swb-retailer-com-role-list-select ref="swb_retailer_com_role_list_select"></swb-retailer-com-role-list-select>',
        data: {},
        okClicked: function () {
            let result = this.$refs.swb_retailer_com_role_list_select.getDlgResult() || {};
            if (result.type == "info") {
                console.log(result.data);
                callback(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        methods: {}
    });
}

// 待入账资产导入检查
export function openShopDeviceFiscalInImpCheckDlg(fileObj, callback) {
    let theDlg = null;
    let title = fileObj.title || "待入账资产导入检查";
    theDlg = Vue.$showDialog({
        title: title,
        width: -100,
        height: -20,
        okVisible: false,
        cancelVisible: false,
        extVisible: true,
        showCloseBtn: true,
        okText: '整体导入',
        extText: '关闭',
        cancelText: '整体检查',
        template: '<swb-shop-device-fiscal-in-imp-devc-check @other-close="otherClose" :rootWidth="dlgBodyWidth" :rootHeight="dlgBodyHeight" :fileObj="fileObj" ref="swb_shop_device_imp_check"></swb-shop-device-fiscal-in-imp-devc-check>',
        data: {
            fileObj: fileObj,
            dlgBodyWidth: 900,
            dlgBodyHeight: 680,
        },
        methods: {
            dlgBodyResized(width, height){
                this.dlgBodyWidth = width;
                this.dlgBodyHeight = height;
            },
            doDeviceFiscalInImpModelImport(deviceImpDto){
                let theLoading = MsgBox.loading("正在执行导入");
                shopDevcApi.doDeviceFiscalInImpModelImport(deviceImpDto, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        callback(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            otherClose(success){
                callback(success);
                theDlg.close();
            }
        },
        okClicked: function () {
            let deviceImpDto = self.$refs.swb_shop_device_imp_check.getDlgResult() || {};
            this.doDeviceFiscalInImpModelImport(deviceImpDto);
            return false;
        },
    });
};

import SwbAssetBizStateImpCheck from './AssetBizStateImpCheck';
Vue.regist(SwbAssetBizStateImpCheck);

export function openAssetBizStateImpCheckDlg(fileObj, callback) {
    let theDlg = null;
    let title = fileObj.title || "资产状态更新导入";
    theDlg = Vue.$showDialog({
        title: title,
        width: -100,
        height: -20,
        okVisible: false,
        cancelVisible: false,
        extVisible: true,
        showCloseBtn: true,
        extText: '关闭',
        template: '<swb-shop-asset-bizState-imp-check @other-close="otherClose" :rootWidth="dlgBodyWidth" :rootHeight="dlgBodyHeight" :fileObj="fileObj" ref="swb_shop_device_imp_check"></swb-shop-asset-bizState-imp-check>',
        data: {
            fileObj: fileObj,
            dlgBodyWidth: 900,
            dlgBodyHeight: 680,
        },
        methods: {
            dlgBodyResized(width, height){
                this.dlgBodyWidth = width;
                this.dlgBodyHeight = height;
            },
            otherClose(success){
                callback(success);
                theDlg.close();
            }
        },
        okClicked: function () {
            let deviceImpDto = self.$refs.swb_shop_device_imp_check.getDlgResult() || {};
            return false;
        },
    });
};

// 未结算资产导入检查 TODO 该功能已删除
export function openShopDeviceOuterUnsettleImpCheckDlg(fileObj, callback) {
    let theDlg = null;
    theDlg = Vue.$showDialog({
        title: "未结算资产导入检查",
        width: -100,
        height: -20,
        okVisible: false,
        cancelVisible: false,
        extVisible: true,
        showCloseBtn: true,
        okText: '整体导入',
        extText: '关闭',
        cancelText: '整体检查',
        template: '<swb-shop-device-outer-unsettled-imp-devc-check @other-close="otherClose" :rootWidth="dlgBodyWidth" :rootHeight="dlgBodyHeight" :fileObj="fileObj" ref="swb_shop_device_imp_check"></swb-shop-device-outer-unsettled-imp-devc-check>',
        data: {
            fileObj: fileObj,
            dlgBodyWidth: 900,
            dlgBodyHeight: 680,
        },
        methods: {
            dlgBodyResized(width, height){
                this.dlgBodyWidth = width;
                this.dlgBodyHeight = height;
            },
            doDeviceOuterUnsettledImpModelImport(deviceImpDto){
                let theLoading = MsgBox.loading("正在执行导入");
                shopDevcApi.doDeviceOuterUnsettledImpModelImport(deviceImpDto, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        callback(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            otherClose(success){
                callback(success);
                theDlg.close();
            }
        },
        okClicked: function () {
            let deviceImpDto = self.$refs.swb_shop_device_imp_check.getDlgResult() || {};
            this.doDeviceOuterUnsettledImpModelImport(deviceImpDto);
            return false;
        },
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/compo/retailer/selectDlg.js
// module id = 17
// module chunks = 0